import React from "react";
import { useTranslation } from "react-i18next";
import Typography from "@/ui/Typography/Typography";
import { useServiceT } from "@/utils/hooks/useServiceT";
import cls from "./styles.module.scss";

interface GoalProgressBlockProps {
  completedRides: number;
  ridesRequired: number;
  variant: "active" | "completed" | "failed";
}

export const GoalProgressBlock = ({
  completedRides,
  ridesRequired,
  variant,
}: GoalProgressBlockProps) => {
  const { t } = useTranslation();
  const serviceT = useServiceT();
  const progress =
    ridesRequired > 0
      ? Math.min((completedRides / ridesRequired) * 100, 100)
      : 0;

  return (
    <div className={cls.progressBlock}>
      <div className={cls.progressMeta}>
        <Typography
          component="span"
          size="md"
          weight="semibold"
          family="Onest"
          color="var(--palette-white)"
        >
          {t("goals.common.progress", {
            completed: completedRides,
            required: ridesRequired,
          })}
        </Typography>
        <Typography component="span" size="sm" weight="bold" family="Onest">
          {serviceT("goals.common.rides", { count: ridesRequired })}
        </Typography>
      </div>
      <div className={cls.progressTrack}>
        <div
          className={[cls.progressFill, cls[variant]].join(" ")}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
